"use client";

import { signIn } from "next-auth/react";

export async function startSignIn(callbackUrl: string = "/"): Promise<void> {
  if (typeof window === "undefined") return;
  await signIn("google", { callbackUrl });
}
